import { useIntercomChat } from 'hooks/common';
import { useLogout } from 'hooks/api/login';
import { Modal, ModalProps } from 'components/Modal';
import Button from 'components/Button';
import messages from './LogoutModal.messages';
import styles from './LogoutModal.module.css';

const LogoutModal = ({
  onRequestClose,
  ...restOfProps
}: ModalProps): JSX.Element | null => {
  const { logoutIntercom } = useIntercomChat();
  const { mutateAsync: logout, isLoading } = useLogout();

  const onLogoutClick = async () => {
    logoutIntercom?.();
    await logout();
  };

  return (
    <Modal {...restOfProps} onRequestClose={onRequestClose}>
      <h3 className={styles.logoutModal__title}>{messages.title}</h3>
      <p className={styles.logoutModal__description}>{messages.description}</p>

      <div className={styles.logoutModal__buttons}>
        <Button variant={'outline'} onClick={onRequestClose}>
          {messages.buttonCancel}
        </Button>
        <Button onClick={onLogoutClick} isLoading={isLoading}>
          {messages.buttonSubmit}
        </Button>
      </div>
    </Modal>
  );
};

export default LogoutModal;
